import SupervisorHome from '../pages/supervisorHome/';
import { TagList } from '../pages/tagGenerator';
import { other } from './supervisor/other';
import { productions } from './supervisor/production';
import { supervisor } from './supervisor/supervisor';

export const IndexSupervisor = [
  {
    path: 'home',
    element: <SupervisorHome />,
  },
  {
    path: 'tagList',
    element: <TagList />,
  },
  ...supervisor,
  ...other,
  ...productions,
];
